import { MCP_CATALOG } from '@/Domain/components/Action/RemoteMCPAction/mcpCatalog';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';

export type CaptureFn = (event: PostHogEventEnum, properties?: Record<string, unknown>) => void;

const MAX_SEARCH_QUERY_LENGTH = 60;

const catalogNameByUrl = new Map(MCP_CATALOG.map((entry) => [entry.url, entry.name]));

/** A low-cardinality, secret-free label for a server: its catalog name, else the URL's hostname.
 *  Never the full URL — a manually entered one can carry an API key in its query string. */
export const remoteMcpServerLabel = (url: string | undefined): string => {
  if (!url) return 'unknown';
  const catalogName = catalogNameByUrl.get(url);
  if (catalogName) return catalogName;
  try {
    return new URL(url).hostname;
  } catch {
    return 'invalid_url';
  }
};

/** Return a bounded service-name search suitable for analytics. URLs, email-like input and long
 * opaque tokens are discarded because users sometimes paste credentials into search fields. */
export const normalizeCatalogQuery = (query: string): string => {
  const normalized = query.trim().toLowerCase().slice(0, MAX_SEARCH_QUERY_LENGTH);
  if (!/^[\p{L}\p{N} .+'-]+$/u.test(normalized)) return '';
  if (normalized.split(/[ .+'-]+/).some((part) => part.length > 24)) return '';
  return normalized;
};
